"use client";

import { usePathname } from "next/navigation";
import type { ReactNode } from "react";
import { FlareErrorBoundary } from "@components/FlareErrorBoundary/FlareErrorBoundary";
import { ReputechFooter } from "@/components/Brand/ReputechFooter";
import { ReputechHeader } from "@/components/Brand/ReputechHeader";
import { useFetchPriceTier } from "@/utils/hooks/useFetchPriceTier";
import { usePersistentCartInit } from "@/utils/hooks/usePersistentCartInit";

const legalPaths = new Set(["/imprint", "/terms", "/privacy"]);

export default function ReputechLayout({ children }: { children: ReactNode }) {
  const pathname = usePathname();
  const isLandingPage = pathname === "/";
  const isLegalPage = legalPaths.has(pathname);

  useFetchPriceTier();
  usePersistentCartInit();

  return (
    <>
      {!isLandingPage && <ReputechHeader />}
      <FlareErrorBoundary>
        <main
          className={
            isLandingPage || isLegalPage
              ? "overflow-hidden"
              : "min-h-[calc(100vh-72px)] bg-[#EFF4F4] px-3 pb-16 pt-8 sm:px-6 sm:pt-12"
          }
        >
          {children}
        </main>
      </FlareErrorBoundary>
      <ReputechFooter />
    </>
  );
}
